/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import proptypes from 'prop-types';
import { Typography, Badge, Link } from '@one-thd/sui-atomic-components';
import { getChristmasDeliveryMessage } from '../helper/christmasMessagingUtils';
import { CHRISTMAS_MESSAGES, DEFAULT_PRODUCTION_URL_ORIGIN, GIFT_CARDS_PLP_URL } from '../constants';
import { isDesktop } from '../helper/utils';

const ChristmasMessaging = ({
  applianceDeliveryData = null,
  fulfillment = null,
  bufferDays = 0,
  checkArrivesAfter = true,
  channel = 'desktop'
}) => {
  const christmasMessage = getChristmasDeliveryMessage({
    applianceDeliveryData,
    fulfillment,
    bufferDays,
    checkArrivesAfter
  });

  if (!christmasMessage) {
    return null;
  }

  const isAfterChristmasMessage = christmasMessage === CHRISTMAS_MESSAGES.AFTER_CHRISTMAS;

  let host = DEFAULT_PRODUCTION_URL_ORIGIN;

  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? DEFAULT_PRODUCTION_URL_ORIGIN
      : window.location.origin;
  }

  const renderAfterChristmasMessage = () => (
    <div data-testid="christmas-messaging-after" className="sui-pt-4">
      <Typography variant="body-base" weight="bold" color="danger">
        {christmasMessage}
        <span data-testid="gift-card-link">
          <Link
            href={`${host}${GIFT_CARDS_PLP_URL}`}
            target={isDesktop(channel) ? '_blank' : '_self'}
            underline="always"
          >
            Instantly send a digital gift card instead!
          </Link>
        </span>
      </Typography>
    </div>
  );

  const renderBeforeChristmasMessage = () => (
    <div data-testid="christmas-messaging-before" className="sui-pt-4">
      <Badge
        color="success"
        size="base"
        variant="strong"
      >
        {christmasMessage}
      </Badge>
    </div>
  );

  return isAfterChristmasMessage ? renderAfterChristmasMessage() : renderBeforeChristmasMessage();
};
ChristmasMessaging.propTypes = {
  applianceDeliveryData: proptypes.object,
  fulfillment: proptypes.object,
  bufferDays: proptypes.number,
  checkArrivesAfter: proptypes.bool,
  channel: proptypes.string
};
ChristmasMessaging.defaultProps = {
  applianceDeliveryData: null,
  fulfillment: null,
  bufferDays: 0,
  checkArrivesAfter: true,
  channel: 'desktop'
};

export { ChristmasMessaging };
